export default __webpack_public_path__ + "static/media/more8.9816865a.jpg";